import { render, staticRenderFns } from "./DocumentBadges.vue?vue&type=template&id=610971e4&scoped=true"
import script from "./DocumentBadges.vue?vue&type=script&lang=js"
export * from "./DocumentBadges.vue?vue&type=script&lang=js"
import style0 from "./DocumentBadges.vue?vue&type=style&index=0&id=610971e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610971e4",
  null
  
)

export default component.exports